module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Silver Aluminum + Yellow Open.209d3c58.png";